import { render, staticRenderFns } from "./configLinkList.vue?vue&type=template&id=3bcf3336&scoped=true&"
import script from "./configLinkList.vue?vue&type=script&lang=js&"
export * from "./configLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf3336",
  null
  
)

export default component.exports